import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';
import { Viaje } from '../../core/models';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ViajeService {
	private viajes: Viaje[] = [];

	constructor(private _apiService: ApiService) {}

	/* GET */
	getViaje(id: number) {
		return this._apiService.get(`/viajes/${id}`);
	}

	getViajeConsultaGeneralById(val: any, verify: string | null) {
		const params = [];
		if (verify) {
			params['verify'] = verify.trim();
		}
		params['id'] = val;
		return this._apiService.get(`/public/viajeCabecera`, params);
	}

	getViajeConsultaGeneralByDominio(val: any) {
		return this._apiService.get(`/public/viajesCabecera`, {
			dominio: val,
		});
	}

	getValidaDominio(dominio: string, claseModalidad?: string, viajeId?: number) {
		return this._apiService.get(`/public/validaDominio`, {
			dominio: dominio,
			claseModalidad: claseModalidad,
			viajeId: viajeId,
		});
	}

	getEmpresaInfo(cnrtNro: number) {
		return this._apiService.get(`/public/empresas/${cnrtNro}`);
	}

	getServiciosEnViaje(fechaInicio: string, fechaFin: string) {
		return this._apiService.get(`/viajes`, {
			'fechaInicio[ge]': fechaInicio,
			'fechaFin[lt]': fechaFin,
		});
	}

	getServicios(_datosFiltro: object) {
		return this._apiService.get(`/viajes`, _datosFiltro);
	}

	getCantViajexDia(empresaId: number, fechaDesde: string, fechaHasta: string) {
		return this._apiService.get(`/tablero/cantViajexDia/${empresaId}`, {
			fechaDesde: fechaDesde,
			fechaHasta: fechaHasta,
		});
	}

	/* POST */
	post(viaje: Viaje) {
		return this._apiService.post('/viajes', viaje);
	}

	/* PUT */
	put(viaje: Viaje) {
		return this._apiService.put(`/viajes/${viaje.id}`, viaje);
	}

	updatePasajeros(viaje: Viaje) {
		return this._apiService.put(`/viajes/${viaje.id}/pasajeros`, viaje);
	}

	/* DELETE */
	delete(id: number, observaciones: string) {
		return this._apiService.put(`/viajes/${id}/cancel`, {
			observaciones: observaciones,
		});
	}

	cambioDominio(viaje: Viaje) {
		return this._apiService.put(`/viajes/${viaje.id}/cambioDominio`, viaje);
	}

	controlDominio(viaje: Viaje) {
		return this._apiService.put(`/viajes/${viaje.id}/controlDominio`, viaje);
	}

	updateChoferes(viaje: Viaje) {
		return this._apiService.put(`/viajes/${viaje.id}/choferes`, viaje);
	}

	findContratante(cuit: string) {
		return this._apiService.get(`/viajes/contratante`, { cuit: cuit });
	}

	getCantTableroEmpresa(empresaId: number) {
		return this._apiService.get(`/tablero/cantTableroEmpresa/${empresaId}`);
	}

	getViajePDFBase64(id: number, hash: string) {
		return this._apiService.get(`/viajes/${id}/pdf?verify=${hash}`);
	}
	observaciones(viaje: Viaje) {
		return this._apiService.put(`/viajes/${viaje.id}/observaciones`, viaje);
	}

	solicitudAuxilio(viaje: Viaje) {
		return this._apiService.put(`/viajes/${viaje.id}/cambioDominio/solicitarAxilio`, viaje);
	}

	darAuxilio(viajeId: number, empresaId: number) {
		return this._apiService.get(`/viajes/${viajeId}/cambioDominio/solicitarAxilio?empresaId=${empresaId}`);
	}

	listadoAseguradoras() {
		return this._apiService.get('/viajes/mostrarAseguradorasTurismo');
	}
}
